const routerList = [
    {
        path: "/sys-manage/access-configuration",
        name: "权限配置",
        component: () => import("@/views/sys-manage/access-configuration/access-configuration.vue"),
        children: [
            {
                path: "/sys-manage/access-configuration/add-role",
                name: "新增角色",
                component: () => import("@/views/sys-manage/access-configuration/children/add-role-info/add-role-info.vue"),
                meta: {
                    nameKey: "addRoleInfo",
                },
            },
            {
                path: "/sys-manage/access-configuration/permission-mune",
                name: "权限配置",
                component: () => import("@/views/sys-manage/access-configuration/children/permission-mune/permission-mune.vue"),
                meta: {
                    nameKey: "permissionMune",
                },
            },
            {
                path: "/sys-manage/access-configuration/operation-log",
                name: "操作日志",
                component: () => import("@/views/sys-manage/access-configuration/children/operation-log/operation-log.vue"),
                meta: {
                    nameKey: "permissionLog",
                },
            },
            {
                path: "/sys-manage/access-configuration/updata-role",
                name: "修改角色",
                component: () => import("@/views/sys-manage/access-configuration/children/role-info/role-info.vue"),
                meta: {
                    nameKey: "updataRoleInfo",
                },
            },
            {
                path: "/sys-manage/access-configuration/details-role",
                name: "角色详情",
                component: () => import("@/views/sys-manage/access-configuration/children/details-role-info/details-role-info.vue"),
                meta: {
                    nameKey: "detailsRoleInfo",
                },
            },
        ],
    },
    {
        path: "/sys-manage/user-manage",
        name: "用户管理",
        component: () => import("@/views/sys-manage/user-manage/user-manage.vue"),
        children: [
            {
                path: "/sys-manage/user-manage/user-detail",
                name: "用户详情",
                component: () => import("@/views/sys-manage/user-manage/children/details-edit/details-edit.vue"),
                meta: {
                    nameKey: "detailsEdit",
                },
            },
            {
                path: "/sys-manage/user-manage/user-edit",
                name: "用户编辑",
                component: () => import("@/views/sys-manage/user-manage/children/user-edit/user-edit.vue"),
                meta: {
                    nameKey: "userEdit",
                },
            },
            {
                path: "/sys-manage/user-manage/add-edit",
                name: "新增用户",
                component: () => import("@/views/sys-manage/user-manage/children/add-edit/add-edit.vue"),
                meta: {
                    nameKey: "userAdd",
                },
            },
            {
                path: "/sys-manage/user-manage/operation-log",
                name: "操作日志",
                component: () => import("@/views/sys-manage/user-manage/children/operation-log/operation-log.vue"),
                meta: {
                    nameKey: "permissionLog",
                },
            },
            {
                path: "/sys-manage/user-manage/assign-sta",
                name: "分配站点",
                component: () => import("@/views/sys-manage/user-manage/children/assign-sta/assign-sta.vue"),
                meta: {
                    nameKey: "assignSta",
                },
            },
        ],
    },
    {
        path: "/sys-manage/log-manage",
        name: "日志管理",
        component: () => import("@/views/sys-manage/log-manage/log-manage.vue"),
    },
    {
        path: "/sys-manage/online-user",
        name: "在线用户",
        component: () => import("@/views/sys-manage/online-user/online-user.vue"),
    },
    {
        path: "/sys-manage/menu-manage",
        name: "菜单配置",
        component: () => import("@/views/sys-manage/menu-manage/menu-manage.vue"),
    },
    {
        path: "/sys-manage/renew-log",
        name: "更新日志",
        component: () => import("@/views/sys-manage/renew-log/renew-log.vue"),
        children: [
            {
                path: "/sys-manage/renew-log/add",
                name: "新增更新日志",
                component: () => import("@/views/sys-manage/renew-log/children/add-renew-log/add-renew-log.vue"),
                meta: {
                    nameKey: "renewLogAdd",
                },
            },
        ],
    },
];
export default routerList;
